var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkLineDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.53125 14.5L14.0312 1",
    stroke: "var(--defaultIconColor)",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5312,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "var(--defaultIconColor)",
    stroke: "var(--defaultIconColor)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.53125,
    y: 11.5,
    width: 3,
    height: 3,
    fill: "var(--defaultIconColor)",
    stroke: "var(--defaultIconColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98716 14.3778L9.69531 10H14.3621L14.0702 14.3778C14.0469 14.728 13.756 15.0001 13.405 15.0001H10.6524C10.3014 15.0001 10.0105 14.728 9.98716 14.3778Z",
    stroke: "var(--defaultIconColor)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 10H15.0313",
    stroke: "var(--defaultIconColor)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9718 9.18234L10.8162 9.64902C10.7587 9.82169 10.8872 10 11.0692 10H12.9959C13.178 10 13.3065 9.82169 13.2489 9.64902L13.0934 9.18234C13.0571 9.07345 12.9552 9 12.8404 9H11.2248C11.11 9 11.0081 9.07345 10.9718 9.18234Z",
    stroke: "var(--defaultIconColor)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3672 11.6665V13.3332",
    stroke: "var(--defaultIconColor)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6328 11.3999V13.0666",
    stroke: "var(--defaultIconColor)",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkLineDelete);
export default __webpack_public_path__ + "static/media/bulk-line-delete.0574b0e64f797e57f5e11407281d950b.svg";
export { ForwardRef as ReactComponent };